// Common app
export const APP_HEADER_HEIGHT = 37
export const TOP_BUTTONS_HEIGHT = 45
export const APP_PADDING = 30
export const APP_FOOTER_HEIGHT = 50

// Tab
export const TAB_HEADER_HEIGHT = 55

// Table
export const TABLE_PADDING = 16
export const PAGING_HEIGHT = 58
export const TABLE_FILTER_HEIGHT = 56

export const COMMON_OUTER_HEIGHT =
  APP_HEADER_HEIGHT +
  TOP_BUTTONS_HEIGHT +
  APP_PADDING * 2 +
  TAB_HEADER_HEIGHT +
  TABLE_FILTER_HEIGHT +
  TABLE_PADDING +
  PAGING_HEIGHT +
  APP_FOOTER_HEIGHT

export const ASIDE_FOOTER_IDS = {
  ACCOUNT: 'aside-footer-accounts',
  SETTINGS: 'aside-footer-settings',
  LANGUAGE: 'aside-footer-languages',
} as const

// Responsive breakpoints (px), based on window width
export const MOBILE_BREAKPOINT = 375
export const TABLET_MIN_WIDTH = 600
export const TABLET_BREAKPOINT = 778
export const LAPTOP_MIN_WIDTH = 1240
export const XL_BREAKPOINT = 1200
export const XXL_BREAKPOINT = 1400
export const LAPTOP_BREAKPOINT = XXL_BREAKPOINT
export const LAPTOP_MAX_WIDTH = 1440
export const TABLET_MAX_WIDTH = LAPTOP_MIN_WIDTH - 1
export const MOBILE_MAX_WIDTH = TABLET_MIN_WIDTH - 1
